import React from 'react';
import type { CSSProperties, ReactNode } from 'react';
import useStyles from '../../theme/useStyles';

// Pairs with useSearch(). The list-view search row.
export interface SearchBarProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  onClear?: () => void;
  /** Rendered to the right of the field — filters, print buttons, etc. */
  actions?: ReactNode;
  style?: CSSProperties;
  /**
   * Sizes the field itself. By default it grows to fill the row; a screen that
   * puts its tabs beside the search passes e.g. `{ flex: '0 1 320px' }`.
   */
  fieldStyle?: CSSProperties;
  isDarkMode?: boolean;
}

const SearchBar = ({
  value,
  onChange,
  placeholder = 'Search...',
  onClear,
  actions,
  style,
  fieldStyle,
  isDarkMode
}: SearchBarProps) => {
  const s = useStyles(isDarkMode);

  return (
    <div style={{ display: 'flex', gap: '10px', marginBottom: s.t.spacing.md, ...style }}>
      <div style={{ position: 'relative', flexGrow: 1, display: 'flex', ...fieldStyle }}>
        <input
          type="text"
          value={value}
          placeholder={placeholder}
          onChange={(e) => onChange?.(e.target.value)}
          style={{ ...s.searchInput, paddingRight: value ? '34px' : undefined }}
        />
        {value && onClear && (
          <button
            type="button"
            onClick={onClear}
            aria-label="Clear search"
            style={{
              position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)',
              background: 'none', border: 'none', color: s.t.textFaint,
              cursor: 'pointer', fontSize: s.t.fontSize.md
            }}
          >
            ✕
          </button>
        )}
      </div>
      {actions}
    </div>
  );
};

export default SearchBar;
